import React, { Component } from 'react'
import { connect } from 'react-redux'

import sessionActions from 'actions/sessionActions'

import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'

export class Login extends Component {
	constructor(props){
		super(props)
		this.state={
			username: ""
		  , password: ""
		}
	}
	render() {
		let { props } = this;
		return(
			<div>
				<div className="wrapper-abstract login-window-container" style={{height: "100vh", backgroundColor: "#00BCD4"}}>
					<div className="empty-login-cell"></div>
					<div className="login-window" >
						<div className="login-window-main-wrapper">
							<div className="textfields">
								<div className="row">
									<TextField
										hintText="Enter your login"
										onChange={(evt) => {
											this.setState({username: evt.target.value, password: this.state.password})
										}}
									/>
								</div>
								<div className="row">
									<TextField
										hintText="Enter your password"
										type="password"
										onChange={(evt) => {
											this.setState({username: this.state.username, password: evt.target.value})
										}}
									/>
								</div>
							</div>
							<div className="main-buttons" style={{marginBottom: "30px"}}>
								<RaisedButton
									onClick={() => {
										props.LOGIN(this.state)
									}}
									label="Login"
									labelColor="#FFF"
									backgroundColor="#43a047"
									style={{float : "left"}}
									className="raized-button"
								/>
							</div>
						</div>
					</div>
					<div className="empty-login-cell"></div>
				</div>
			</div>
		)
	}
}

export default connect(null, sessionActions)(Login)



// WEBPACK FOOTER //
// ./src/components/Login/index.js